import { useGetActivityLogQuery } from "../../services/activityLogApi";
import { HistoryOutlined } from "@mui/icons-material";
import { AdminPageHeader, AdminTable, AdminBadge } from "../../components/ui";
import { formatDateTimeIso } from "../../utils/format";

const ACTION_LABEL = {
  CREATE: "Created",
  UPDATE: "Updated",
  DELETE: "Deleted",
  STATUS_CHANGE: "Status changed",
};

const ACTION_VARIANT = {
  CREATE: "success",
  UPDATE: "info",
  DELETE: "danger",
  STATUS_CHANGE: "warning",
};

function ActivityLog() {
  const { data, isLoading, isError } = useGetActivityLogQuery();
  const rows = data?.results ?? [];

  const columns = [
    {
      key: "action",
      header: "Action",
      render: (e) => <AdminBadge variant={ACTION_VARIANT[e.action] || "neutral"}>{ACTION_LABEL[e.action] || e.action}</AdminBadge>,
    },
    { key: "description", header: "Description" },
    { key: "actor_name", header: "Actor" },
    { key: "created_at", header: "When", render: (e) => formatDateTimeIso(e.created_at) },
  ];

  return (
    <div className="activityLog">
      <AdminPageHeader
        title="Activity Log"
        subtitle="A record of changes made across the admin panel."
        breadcrumbs={[{ label: "Dashboard", to: "/admin/dashboard" }, { label: "Activity Log" }]}
      />
      <AdminTable
        columns={columns}
        rows={rows}
        rowKey={(e) => e.id}
        isLoading={isLoading}
        emptyIcon={<HistoryOutlined />}
        emptyTitle={isError ? "Couldn't load the activity log" : "No activity recorded yet"}
        emptyDescription={isError ? "Something went wrong. Try refreshing the page." : undefined}
        pageSize={15}
      />
    </div>
  );
}

export default ActivityLog
